import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import SubHeader from "@cayuse/shared-react.components.sub-header";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { awardSelectors } from "store/selectors";
import { refreshReviewEvents } from "store/actions/award";
import { useDictionary } from "hooks";
import RoutingTable from "components/RoutingTable";

import styles from "./styles.css";


const Routing = () => {
	const { isFetching, error, awardId, reviewEvents, certificationEvents, formRules, round } = useSelector(awardSelectors.award);
	const dictionary = useDictionary("awards.routing");

	useEffect(() => {
		if (isNonEmptyString(awardId)) {
			refreshReviewEvents(awardId);
		}
	}, []);

	return (
		<div data-component="Routing">
			<SubHeader className={styles.heading}>{dictionary.sectionHeading || "Routing for Review"}</SubHeader>
			<RoutingTable
				formRules={formRules}
				reviewEntries={reviewEvents}
				certificationEntries={certificationEvents}
				currentRound={round}
				isLoading={isFetching}
				hasError={isNonEmptyString(error)}
				dictionary={dictionary}
			/>
		</div>
	);
};

export default Routing;
